module.exports = __webpack_public_path__ + "components/flag/static/square/tl-0a98ff599f11cc7ed5d16916fb08a8ff.svg";